import { MongoObservable } from 'meteor-rxjs';
import { PreviousJob } from '../models/previousJob';

export const PreviousJobs = new MongoObservable.Collection<PreviousJob>(
  'previousJobs',
);
